export default __webpack_public_path__ + "static/media/information--charging-station--g1.38a12cae.png";